<template>
  <div>
   <app-masthead :header="header"/> 
  <v-container grid-list-xl>
    <v-layout wrap row class="mb-5">
      <v-flex xs12>
        <h2 style="font-size: 36px; font-weight: bold; line-height: 1.2;" class="mb-2">Schenke jedem Tag ein wenig Aufmerksamkeit.</h2>
        <p>Ein Kartenset, welches deinen Alltag durch tägliche Achtsamkeitübungen bereichert! Aus sechs Kategorien ziehst du jeden Tag eine Karte und bekommst eine simple Aufgabe für den Tag gestellt, welche deinen Alltag mit ein bisschen mehr Aufmerksamkeit bereichern soll!</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap >
      <v-flex offset-xs0 xs12 offset-sm0 sm6 offset-md0 md6>
        <h4>Vorderseite</h4>
        <div class="ip-card">
          <img width="100%" src="@/assets/ip-karten_01.jpg" alt="">
        </div>
      </v-flex>
      <v-flex offset-xs0 xs12 offset-sm0 sm6 offset-md0 md6>
        <h4>Rückseite</h4>
        <div class="ip-card">
          <img width="100%" src="@/assets/ip-karten_02-r.jpg" alt="">
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 style="margin-top: 50px; text-align: center;">
        <h3>Kooperation mit DESIGNDIALOG.store</h3>
        <p>Dank dem <a href="https://designdialog.store/" target="_blank">DESIGNDIALOG.store</a> können wir dir eine sichere und einfache Möglichkeit bieten unsere Karten zu erwerben. Innerhalb von Deutschland ist der Versand für dich kostenfrei.</p>
      </v-flex>
      <v-flex xs12>
        <div id='my-product' style="margin: 30px auto;"></div>
      </v-flex>
    </v-layout>


    <!-- <v-layout row wrap style="margin: 100px auto;">
      <v-flex xs12 sm8 offset-sm2 style="text-align: center">
        <h3>Karten vorbestellen</h3>
        <p>Du hast dich dazu entschieden, dir oder deinen Liebsten ein Basisset zu schenken? Dann folge einfach dem Link und schließe die Bestellung ab.</p>
        <v-btn color="warning" class="elevation-0">Jetzt vorbestellen <v-icon right>keyboard_arrow_right</v-icon></v-btn>
      </v-flex>
    </v-layout> -->
    <v-layout class="mt-5">
      <v-flex>
        <v-card flat style="background-color: transparent">
          <v-card-title>
            <v-flex>
              <h3>Haben wir dein Interesse geweckt?</h3>
              <p>Du hast Interesse an unseren Karten, hast Fragen oder Anregungen? Schreib uns doch einfach! 😊 </p>
              <v-btn flat outline href="mailto:hello@ideenpioniere.de?subject=Interesse an Achtsamkeitskarten"><v-icon left>mail</v-icon>E-Mail verfassen</v-btn>
              <v-btn class="elevation-0" color="warning" :to="{ name: 'aktuelles' }">zu den aktuellen Infos<v-icon right>keyboard_arrow_right</v-icon></v-btn>
            </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <app-cta-newsletter/>
    <!-- <v-flex xs12><v-card outline flat class="pa-5" style="text-align: center; background-color: rgba(0, 0, 0, 0.03); border: 1px solid rgba(0, 0, 0, 0.24); color: rgba(0, 0, 0, 0.4);">Ab dem 24.10.2018 erscheinen hier Informationen zu den Karten.</v-card></v-flex> -->
  </v-container>
  </div>
</template>

<script>
import ui from '@/plugins/js-buy-sdk'

export default {
  data () {
    return {
      header: {
        src: require('@/assets/ip-header-karten.svg'),
        title: 'Für Dich!',
        description: 'Lasse dich jeden Tag von Neuem inspirieren.'
      },
    }
  },
  mounted () {
    ui.createComponent('product', {
      id: [1997215072369],
      node: document.getElementById('my-product'),
      moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
      options: {
        "product": {
          "variantId": "all",
          "width": "240px",
          "contents": {
            "imgWithCarousel": false,
            "variantTitle": false,
            "description": false,
            "buttonWithQuantity": false,
            "quantity": false
          },
          "styles": {
            "product": {
              "@media (min-width: 601px)": {
                "max-width": "100%",
                "margin-left": "0",
                "margin-bottom": "50px"
              }
            },
            "button": {
              "background-color": "#e57084",
              ":hover": {
                "background-color": "#ce6577"
              },
              ":focus": {
                "background-color": "#ce6577"
              }
            },
            "compareAt": {
              "font-size": "12px"
            }
          }
        },
        "cart": {
          "contents": {
            "button": true
          },
          "styles": {
            "button": {
              "background-color": "#e57084",
              ":hover": {
                "background-color": "#ce6577"
              },
              ":focus": {
                "background-color": "#ce6577"
              }
            },
            "footer": {
              "background-color": "#ffffff"
            }
          }
        },
        "modalProduct": {
          "contents": {
            "img": false,
            "imgWithCarousel": true,
            "variantTitle": false,
            "buttonWithQuantity": true,
            "button": false,
            "quantity": false
          },
          "styles": {
            "product": {
              "@media (min-width: 601px)": {
                "max-width": "100%",
                "margin-left": "0px",
                "margin-bottom": "0px"
              }
            },
            "button": {
              "background-color": "#e57084",
              ":hover": {
                "background-color": "#ce6577"
              },
              ":focus": {
                "background-color": "#ce6577"
              }
            }
          }
        },
        "toggle": {
          "styles": {
            "toggle": {
              "background-color": "#e57084",
              ":hover": {
                "background-color": "#ce6577"
              },
              ":focus": {
                "background-color": "#ce6577"
              }
            },
            "count": {
              "color": "#ffffff",
              ":hover": {
                "color": "#ffffff"
              }
            },
            "iconPath": {
              "fill": "#ffffff"
            }
          }
        },
        "productSet": {
          "styles": {
            "products": {
              "@media (min-width: 601px)": {
                "margin-left": "-20px"
              }
            }
          }
        }
      }
    });
  }
}
</script>


<style lang="scss">
  #card-header {
    padding-bottom: 150px;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    @media screen and (max-width: 960px) {
      background-size: cover;
    }
  }

  .card-head {
    .card-head-img {
      width: auto;
      height: 200px;
    }
    .v-image__image {
      opacity: 0.5;
    }
  }

  .ip-card {
    box-shadow: 0 5px 15px 0px rgba(0,0,0,0.3);
    transform: translatey(0px);
    border-radius: 20px;
    overflow: hidden;

    img {
      display: block;
    }
  }
</style>
